<div class="ct-main-content">
  <div class="ct-container" [class.margin-bottom]="!isCheckout">
    <div class="cart-label">
      PEDIDO {{orderNumber ? '#' + orderNumber : ''}}
      @if (!orderNumber && isCheckout) {
        <div class="unsent-notice">
          (após verificar as informações, <a href="#" (click)="scrollDown($event)">conclua o pedido</a>)
        </div>
      }
    </div>
    @if (items == null || items.length == 0) {
      <div class="no-items">
        <hr/>
        Ainda não há nenhum item adicionado
      </div>
    }

    <div class="cart-items">
      @for (item of items; track item) {
        <div class="cart-item">
          <hr/>
          <div class="item-header">
            <span class="item-name clipped">
              {{item.product.delivery_name || item.product.name}}
            </span>
            <span class="product-price">
              Preço un. {{(item.prettyUnitaryPrice || item.product.price).replace('.',',')}}
            </span>
          </div>
          <div class="item-body">
            <span class="item-image">
              <img src="{{serverUrl}}{{item.product.picture_path.url || '/default.png'}}"/>
            </span>
            <ul class="item-notes">
              @for (note of item.notes_obj; track note) {
                <li class="item-note">
                  <input [disabled]="isCheckout" type="text" class="note-input" [(ngModel)]="note.text" (keyup)="changeNotes(item)"/>
                </li>
              }
            </ul>
            @if (item.poptional_selections.length > 0) {
              <div class="poptionals">
                <i>OPÇÕES:</i>
                <ul>
                  @for (sel of item.poptional_selections; track sel) {
                    <span>
                      @for (lbl of sel.descriptions(); track lbl) {
                        <li>
                          @if (lbl.qty > 1) {
                            <b>{{lbl.qty}} </b>
                            }{{lbl.text}}
                            @if (lbl.price > 0) {
                              <span>+{{lbl.price | currency:'BRL'}}</span>
                            }
                          </li>
                        }
                      </span>
                    }
                  </ul>
                </div>
              }
            </div>
            <div class="item-footer">
              <div class="item-quantity">
                @if (isCheckout) {
                  <span>Qtd: &nbsp; {{item.quantity}}</span>
                }
                @if (!isCheckout) {
                  <app-qty-button class="qty-btn" [quantity]="item.quantity" (change)="changeQuantity(item, $event)" min="0"></app-qty-button>
                }
              </div>
              <span class="item-price">
                Total: {{item.prettyPrice}}
                @if (!isCheckout) {
                  <div>
                    <button class="btn btn-sm btn-danger" (click)="removeItem(item)">Remover</button>
                  </div>
                }
              </span>
            </div>
          </div>
        }
      </div>

      <hr/>

      <div class="cart-footer">
        <div class="cart-total">{{isCheckout ? 'SUB':''}}TOTAL: &nbsp; {{prettyTotal}}</div>
        @if (!isCheckout) {
          <div class="cart-actions">
            <button class="btn btn-lg btn-secondary back-button" (click)="goBack()">Voltar</button>
            <button class="btn btn-lg btn-primary" (click)="customerInfo()" [disabled]="items.length == 0">Prosseguir</button>
          </div>
        }
      </div>
    </div>
  </div>